import React, { Fragment, useEffect } from 'react'
import {
  InfosContainer,
  StyleProfileInfoWrapper,
} from '../../../provider-details/style'
import { StyleLabel, StyleTextContaienr } from '@components/fields/style'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Typography from '@components/typography'
import {
  StyleImage,
  StyleImageGrid,
} from '@pages/admin/user-management/providers/individual-provider/vehicles/individual-vehicle/bus-details/style'
import Grid from '@components/grid'
import useIsMobile from '@hooks/useIsMobile'

const BusDetails = ({ data }) => {
  const profileData = [
    { label: 'Vehicle Name', value: data?.name },
    { label: 'Vehicle Number', value: data?.number },
    { label: 'Vehicle Type', value: data?.type },
    { label: 'Vehicle Layout', value: data?.layout?.name },
  ]

  const amenities = data?.amenities ?? []

  const images = data?.images ?? []
  const isMobile = useIsMobile()
  return (
    <Fragment>
      {isMobile ? (
        <Grid>
          {profileData.map((d, i) => (
            <StyleProfileInfoWrapper key={i}>
              <StyleLabel>{d.label}</StyleLabel>
              <StyleTextContaienr style={{ marginBottom: '5px' }}>
                {d.value ?? '-'}
              </StyleTextContaienr>
            </StyleProfileInfoWrapper>
          ))}
        </Grid>
      ) : (
        <InfosContainer
          style={{
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: '20px',
          }}
        >
          {profileData.map((d, i) => (
            <StyleProfileInfoWrapper key={i}>
              <StyleLabel>{d.label}</StyleLabel>
              <StyleTextContaienr>{d.value ?? '-'}</StyleTextContaienr>
            </StyleProfileInfoWrapper>
          ))}
        </InfosContainer>
      )}

      <Formik
        initialValues={{
          amenities: (amenities ?? []).map((a) => a.id), // only this bus' amenities
        }}
        onSubmit={() => {}}
        enableReinitialize
      >
        <Form>
          <Fields.ChooseButton
            name="amenities"
            label="Amenities"
            items={amenities || []} // show ALL amenities from API/Redux
            titleAsKey="name"
            valueAsKey="id"
            icon=""
          />
        </Form>
      </Formik>
      <br />
      <Typography>Bus Images</Typography>
      <br />
      {images?.length > 0 && (
        <StyleImageGrid>
          {images?.map((img, idx) => (
            <StyleImage
              key={idx}
              src={`${process.env.APP_BUCKET_URL}/${img.image}`}
              alt={`vehicle-img-${idx}`}
            />
          ))}
        </StyleImageGrid>
      )}
    </Fragment>
  )
}

export default BusDetails
